import { useEffect, useState } from "react";
import { fetchHomePage } from "./utils/PageUtils";
import SectionRenderer from "./components/sections/SectionRenderer";
import "./css/pageLayout.css"

function NewHomePage() {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchHomePage()
      .then((data) => setPageData(data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!pageData) return <p>No page found</p>;

  const mainSections = pageData.sections.filter(
    (section) => section.zone === "main"
  );

  const sidebarSections = pageData.sections.filter(
    (section) => section.zone === "sidebar"
  );

  return (
    <main>
      <div className="page-layout">
        <section className="main-content" style={{marginTop: "15px"}}>
          {mainSections.map((section) => (
            <SectionRenderer key={section.id} section={section} />
          ))}
        </section>

        <aside className="sidebar" style={{marginTop:"50px"}}>
          {sidebarSections.map((section) => (
            <SectionRenderer key={section.id} section={section} />
          ))}
        </aside>
      </div>
    </main>
  );
}

export default NewHomePage;